import {
  DetailedDrop,
  DetailedDrop_DropStatus,
} from '@aboutyou/legacy-shared/src/grpc_client/grips/protos/shared/detailed_drop'
import {
  getTimelyLimitedDropReleasedUntilDate,
  isTimelyUnlimitedDrop,
} from '@aboutyou/legacy-shared/src/ui/Drops/utils/helper'
import useDropCountDownText from '@aboutyou/legacy-shared/src/utils/hooks/useDropCountDownText'
import { exists } from 'helpers/exists'
import { useDropTranslations } from 'pages/Drops/useDropTranslations'
import React, { FC, RefObject } from 'react'
import { DropDetailsCountdown } from 'uiComponents/atoms/Drops/DropDetailsCountdown'

export const StickyCountdown: FC<{
  drop: DetailedDrop
  dropDetailsWrapperRef: RefObject<HTMLDivElement | null> | null
}> = ({ drop, dropDetailsWrapperRef }) => {
  const translations = useDropTranslations()

  const dropStatus = drop.dropStatus
  const isActiveDrop = dropStatus === DetailedDrop_DropStatus.ACTIVE
  const isPastDrop = dropStatus === DetailedDrop_DropStatus.PAST
  const isUpcomingDrop = dropStatus === DetailedDrop_DropStatus.UPCOMING
  const isLastChanceDrop = dropStatus === DetailedDrop_DropStatus.LAST_CHANCE

  const translationText = isActiveDrop
    ? translations.releasedUntil
    : translations.overview.passedDrop.expired

  const { countdownPillText } = useDropCountDownText(
    {
      releasedFrom: drop.releasedFrom,
      releasedUntil: getTimelyLimitedDropReleasedUntilDate(drop),
    },
    {
      isActiveDrop,
      // for timely unlimited drop the releaseFrom is used
      // for timely limited drop the releasedUntil is used
      isUpcomingDrop,
    },
  )

  const hideCountdownForTimelyUnlimitedDrop =
    isTimelyUnlimitedDrop(drop) && (isActiveDrop || isPastDrop)

  if (
    !exists(dropDetailsWrapperRef) ||
    !countdownPillText ||
    isLastChanceDrop ||
    hideCountdownForTimelyUnlimitedDrop
  ) {
    return null
  }

  return (
    <DropDetailsCountdown
      isPastDrop={isPastDrop}
      text={!isPastDrop ? countdownPillText : translationText}
      dropDetailsWrapperRef={dropDetailsWrapperRef}
    />
  )
}
